import React from 'react';

const ActionButton = ({ onClick, disabled, children }) => {
  const handleClick = event => {
    event.preventDefault();
    event.stopPropagation();

    if (!disabled) {
      onClick?.(event);
    }
  };

  return (
    <a
      className={`action-button ${disabled ? 'action-button--disabled' : ''}`}
      role="button"
      tabIndex="0"
      onClick={handleClick}
    >
      {children}
    </a>
  );
};

export default ActionButton;
